<template>
  <el-container class="home_page" @click="close_user_pop">
    <el-header class="header" ref="header" height="60px">
      <div class="title font_weight_600" ref="title" @click="goToHomeView">
        <el-image class="image_title" :src="showImg(hos_msg.sys_picture)" v-if="hos_msg.sys_picture" fit="contain">
          <div slot="placeholder" class="image-slot">
            暂无图片
          </div>
        </el-image>
        <span id="hos_title_text">{{ hos_msg.hos_name }}</span>
      </div>
      <div class="tab_list" ref="tabList" @mousewheel="mouseWheelTabList">
        <template v-for="(item, index) in tabList" :key="index">
          <div class="tab_item" :class="componentId == item.value ? 'active_item' : ''"
            @click="changeTabSearchVerify(item.value)" v-if="showTab(item.power)">
            {{ item.name }}
          </div>
        </template>
      </div>
      <div class="right_btn" ref="right_btn">
        <el-popover placement="bottom" :width="200" trigger="click" :visible="show_pop">
          <template #reference>
            <div class="user_box" @click.stop="show_pop = !show_pop">
              <img class="user_img" v-if="userData.avatar" :src="imageUrl(userData.avatar)" alt="">
              <img class="user_img" v-else src="../assets/com_img/doctor.png" alt="">
              <div class="user_name">{{ userData.name || userData.user_name }}
              </div>
            </div>
          </template>

          <div class="user_btn_box" style="display: flex;justify-content: space-around;">
            <div class="btns">
              <el-button size="small" @click="openEdit">修改密码
              </el-button>
            </div>
            <div class="bottom_btn">
              <el-button type="danger" @click="loginOut" size="small">退出登录
              </el-button>
            </div>

          </div>
        </el-popover>
      </div>
    </el-header>
    <el-container>
      <el-aside class="aside_box">
        <el-menu class="el-menu-vertical-demo homeSide" ref="homeSide" :default-active="activeIndex"
          :default-openeds="openeds" @open="setOpeneds" :unique-opened="true" :collapse="false">
          <template v-for="(item, index) in showSide">
            <el-menu-item :index="item.index" @click="changeComponent(item)" v-if="sideTabShow(item) && !item.children">
              <i :class="item.icon"></i>
              <template #title><span>{{ item.name }}</span></template>
            </el-menu-item>

            <el-sub-menu :index="item.index" v-if="sideTabShow(item) && item.children" popper-class='homeSideSubmenu'>
              <template #title>
                <i :class="item.icon"></i>
                <span>{{ item.name }}</span>
              </template>

              <el-menu-item-group>
                <template v-for="(child, indexs) in item.children" :index="child.index">
                  <el-menu-item @click="changeComponent(child)" v-if="sideTabShow(child)"
                    :class="child.index == activeIndex ? 'is-active' : ''" :key="indexs">
                    <i :class="child.icon"></i>
                    <span>{{ child.name }}</span>
                  </el-menu-item>
                </template>
              </el-menu-item-group>
            </el-sub-menu>
          </template>
        </el-menu>
      </el-aside>
      <el-main class="main" :class="pathname.indexOf('hospaInfo') > -1 ? 'padt_30' : ''"
        :style="`height: ${mainHeight}px;`">
        <div class="main_box">
          <router-view></router-view>
        </div>
      </el-main>
    </el-container>
  </el-container>

  <el-dialog :title="dialogTitle" v-model="dialogVisible" :close-on-click-modal="false"
    :close-on-press-escape="show_dialog_cancel" :show-close="show_dialog_cancel" destroy-on-close width="500px">
    <el-form :model="edit_form" ref="edit_form" :rules="rules" size="large" label-width="150px">
      <el-form-item label="旧密码：" v-if="login_by_password" prop="old_password">
        <el-input v-model="edit_form.old_password" type="password" show-password placeholder="请输入旧密码"
          class="width_220"></el-input>
      </el-form-item>
      <el-form-item label="验证码：" v-else prop="vcode">
        <el-input v-model="edit_form.vcode" autocomplete="new-password" placeholder="请输入验证码"
          class="width_150"></el-input>
        <el-button size="large" style="margin-left: 10px;width: 100px;" @click="getVCodeByPhone"
          :disabled="code_btn_num > 0">
          <span v-if="code_btn_num > 0">{{ code_btn_num }} S</span>
          <span v-else>获取验证码</span>
        </el-button>
      </el-form-item>
      <el-form-item label="新密码：" prop="new_password">
        <el-input v-model="edit_form.new_password" autocomplete="new-password" placeholder="请输入新密码" type="password"
          show-password class="width_220"></el-input>
      </el-form-item>
      <el-form-item label="确认新密码：" prop="is_new_pass">
        <el-input v-model="edit_form.is_new_pass" type="password" show-password placeholder="请再次输入新密码"
          class="width_220"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false" v-if="show_dialog_cancel">取 消</el-button>
        <el-button @click="loginOut()" v-else type="danger">退出登录</el-button>
        <el-button type="primary" @click="editPassword('edit_form')">确 定</el-button>
      </span>
    </template>
  </el-dialog>
  <el-dialog :title="dialogTitleMsg" v-model="dialogVisibleMsg" :close-on-click-modal="false" destroy-on-close
    width="450px">
    <el-form :model="msg_data" label-width="100px">
      <el-form-item v-for="(item, index) in form_prop" :key="index" :label-width="item.labelWidth"
        :label="item.name + '：'">
        <span>{{ msg_data[item.prop] }}</span>
      </el-form-item>
      <el-form-item label-width="10px">
        <span class="msg_note">（{{ msg_data.msg }}）</span>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisibleMsg = false">关 闭</el-button>
      </span>
    </template>
  </el-dialog>

  <!-- <lock-view></lock-view> -->
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex"
import { clone, ssGet, ssSet, ssRemove, lcRemove, lcGet } from "../utils/utils";
import { authShow } from "@/utils/mixins";
import lockView from '@/components/com_components/lockView'
import side from "./homeSide"
import tabOption from './tabOption'
import config from '@/global/config';

export default {
  name: 'homeView',
  components: { lockView },
  mixins: [authShow],
  data() {
    const checkPassNew = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入新密码'))
      } else {
        let length = value.toString().length;
        if (length < 12) {
          callback(new Error('密码至少为12位'))
        }
        let type = 0;
        if (!(value.match(/\d+/g) == null)) {
          type++
        }
        if (!(value.match(/[a-z]+/g) == null)) {
          type++
        }
        if (!(value.match(/[A-Z]+/g) == null)) {
          type++
        }
        if (!(value.match(/[~!@#$%^&*()_=+]+/g) == null)) {
          type++
        }
        if (type < 3) {
          callback(new Error('密码至少包含大写、小写、数字、特殊字符里面的三种'))
        }

        if (length > 30) {
          callback(new Error('密码最多为30位'))
        }
        callback()
      }

    };
    const checkPass = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请确认新密码'))
      }
      if (value != this.edit_form.new_password) {
        callback(new Error('新密码两次输入不一致'))
      }
      callback()
    };
    return {
      tablistWidth: 500,
      pathname: '',
      mainHeight: window.innerHeight - 60,
      dialogVisible: false,
      dialogTitle: '修改密码',
      edit_form: {},
      rules: {
        vcode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        old_password: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        new_password: [{ required: true, validator: checkPassNew, trigger: 'blur' }],
        is_new_pass: [{ required: true, validator: checkPass, trigger: 'blur' }]
      },

      dialogTitleMsg: '关于',
      dialogVisibleMsg: false,
      msg_data: {
        title: '肺结节CT图像辅助检测软件',
        specification: 'HH-LungNodule',
        release_note: '1',
        full_version: '1.0.5.01',
        person: '上海皓桦科技股份有限公司',
        person_adress: '上海市闵行区园美路58号1幢305室',
        number: '',
        msg: '注：其他内容详见产品说明书'
      },
      form_prop: [
        { name: '产品名称', prop: 'title' },
        { name: '型号规格', prop: 'specification' },
        { name: '发布版本', prop: 'release_note' },
        { name: '完整版本', prop: 'full_version' },
        { name: '注册人', prop: 'person' },
        { name: '注册人住所', prop: 'person_adress' },
        { name: '医疗器械注册证编号', prop: 'number', labelWidth: "155px" },
        // {name: '', prop: 'msg'},
      ],

      code_btn_num: 0,
      vcode_int: null,

      login_by_password: true,
      show_dialog_cancel: true,
      show_pop: false,

      activeIndex: '',
      openeds: [],
      showSide: side,
      tabList: [],
      tabId: '',
    }
  },
  computed: {
    ...mapState('homeData', [
      'hos_msg',
      'userData',
      'app_env',
      'now_auth',
    ]),
    ...mapState('patientData', ['patient']),
    ...mapState('powerData', {
      authority: 'authority',
      componentId: 'componentId'
    }),
    show_message_text() {
      let text = this.app_env == 'dev' ? '该版本为开发环境'
        : this.app_env == 'test' ? '该版本为135测试环境'
          : this.app_env == 'prev' ? '该版本为体验测试环境'
            : this.app_env == 'prod' ? ''
              : '测试环境';
      return text
    }
  },
  watch: {
    $route(to, from) {
      this.pathname = to.path;
      // console.log(this.pathname,' this.pathname');

    },
  },
  mounted() {

    window.addEventListener('resize', this.handleResize)

    setTimeout(() => {
      this.getTablistWidth()
    }, 0);
    this.getComConfig().then(res => {
      this.fontSizeAuto();
      this.getAuthority();
      this.getCommonData();
      let data = ssGet('user');
      if (data) {
        this.setUserData(data);
        this.checkUserDays()

        this.getAllList();
        this.getIssueList()
        this.getUserRoleProjects()

        let login_type = ssGet('login_type');
        console.log(JSON.parse(data), login_type, '302');

        // 没有设置过密码必须设置密码才能使用
        if (JSON.parse(data).set_password == '1') {
          this.show_dialog_cancel = false
          this.dialogVisible = true;
        }



      } else {
        sessionStorage.clear();
        // localStorage.clear();
        lcRemove('token')
        this.$router.push('login');
      }
    });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.mainHeight = window.innerHeight - 60
    },
    ...mapMutations('homeData', {
      setUserData: 'setUserData',
      setHosMsg: 'setHosMsg',
      setDictionSelect: 'setDictionSelect',
      setRoleProjectIds: 'setRoleProjectIds',
      setNowAuthData: 'setNowAuthData',
      setOrgList: 'setOrgList',
      // 课题列表
      setIssueList: 'setIssueList',
    }),
    ...mapActions('homeData', {
      getAuthorityData: 'getAuthorityData',
      getComConfig: 'getComConfig',
    }),
    ...mapMutations('powerData', {
      setPower: 'setPower',
      setPowerComponentId: 'setComponentId',
    }),
    mouseWheelTabList(e) {
      let dom = this.$refs.tabList;
      dom.scrollLeft += e.deltaY;
    },
    getTablistWidth() {
      if (!this.$refs.header?.$el || !this.$refs.title || !this.$refs.right_btn) return
      let all = this.$refs.header.$el.clientWidth;
      let left = this.$refs.title.clientWidth;
      let right = this.$refs.right_btn.clientWidth;
      this.tablistWidth = all - left - right - 50;
    },
    getAllList() {
      let userData = ssGet('user')
      if (!userData) {
        this.$router.push('login')
        return
      }
      let organization_id = JSON.parse(userData).bind_org_id[0]
      let params = {
        is_all: 2,
        organization_id,
        special: true
      };
      this.$http.get('/dict/list', params).then(res => {
        this.setDictionSelect(res.result)
      })
    },
    // 课题列表
    getIssueList() {
      let params = { is_all: 2 }
      this.$http.get('/project_list', params).then(res => {
        this.setIssueList(res.data)
      })
    },
    // 获取当前用户角色的课题限制范围
    getUserRoleProjects() {
      let userData = ssGet('user')
      if (!userData) return
      userData = JSON.parse(userData)
      let roleProjectIds = userData.role_project_ids || []
      this.setRoleProjectIds(roleProjectIds)
    },
    close_user_pop() {
      if (this.show_pop) {
        this.show_pop = false;
      }
    },

    checkUserDays() {
      if (this.userData.password_expire_days < 8) {
        this.$http.warning('密码即将过期，请尽快修改密码', true, 3000)
      }
    },


    getVCodeByPhone() {
      let phone = this.userData.phone;
      let params = {
        phone: phone,
      };
      this.$http.post('/send_vcode', params).then(res => {
        this.changeVcodeTime();
      })
    },
    changeVcodeTime() {
      this.code_btn_num = 60;
      this.vcode_int = setInterval(() => {
        this.code_btn_num--;
        if (this.code_btn_num < 1) {
          clearInterval(this.vcode_int)
        }
      }, 1000)
    },

    // 获取当前url
    changeUrlName(path) {
      this.pathname = '/' + path;
      // console.log(this.pathname, 'this.pathname');
    },
    fontSizeAuto() {
      let innerB = document.getElementById('hos_title_text');
      if (!innerB) return;
      let innerW = innerB.innerHTML.length;
      if (innerW > 6) {
        let size = 200 / innerW;
        innerB.style.fontSize = size + 'px'
      } else {
        innerB.style.fontSize = '22px'
      }
    },
    showImg(url) {
      return this.$http.getImageUrl(url)
    },
    imageUrl(url) {
      return this.$http.getImageUrl(url, 1)
    },
    goToView(item) {
      this.$router.push(item.route);
    },
    goToHomeView() {
      // let first = 'report-list';
      // if (this.showTab([first])) {
      //     this.$router.push('reportTable');
      // }
    },
    getCommonData() {
      this.$http.get('/organization_list').then(res => {
        this.setOrgList(res.data)
      });
    },
    getAuthority() {

      // this.setNowAuthData([
      //   "setting-user-read",
      //   "setting-user-write",
      //   "setting-user-delete",
      //   "setting-role-read",
      //   "setting-role-write",
      //   "setting-role-delete",
      //   "setting-medical-read",
      //   "setting-medical-write",
      //   "setting-medical-delete",
      //   "business-hospa-read",
      //   "business-hospa-write",
      //   "business-hospa-delete",
      //   "business-ocr-read",
      //   "business-ocr-write",
      //   "business-ocr-delete",
      //   "setting-apply-read",
      //   "setting-apply-write",
      //   "setting-apply-delete"
      // ])
      this.getAuthorityData().then(res => {
        // res.authority
        let query = this.$route.query;
        let homeSide = this.$refs.homeSide;
        console.log(query, 'query');

        if (query.path) {
          this.showSide.forEach((v) => {
            if (v.url == query.path) {
              this.activeIndex = v.index;
              homeSide.open(v.index)
            }
            if (v.children) {
              v.children.forEach((child) => {
                if (child.url == query.path) {
                  this.activeIndex = child.index;
                  homeSide.open(v.index)
                }
              })
            }
          })
          this.$router.push(query.path);
        } else {
          if (!this.patient || !this.patient.patient_id) {
            this.$router.push('homeview');
          } else {
            this.pathname = this.$route.path;
          }
        }
      });
    },

    loginOut() {
      this.$http.get('/logout').then(res => {
        sessionStorage.clear();
        // localStorage.clear();
        lcRemove('token')
        this.$router.push('login');
        this.$http.successing('登出成功！')
      })
    },
    openEdit() {
      this.edit_form = {
        old_password: '',
        new_password: '',
        is_new_pass: '',
      };
      this.dialogVisible = true;
    },
    editPassword(ref) {
      this.$refs[ref].validate(valid => {
        if (valid) {
          let params = {
            new_password: this.edit_form.new_password,
          }

          if (this.login_by_password) {
            params.old_password = this.edit_form.old_password;
          } else {
            params.vcode = this.edit_form.vcode;
            params.phone = this.userData.phone;
          }
          this.$http.post('/user/password/update', params).then(res => {
            this.$http.successing('修改密码成功，请重新登录');
            this.dialogVisible = false;
            this.loginOut()
          }).catch(err => {
            this.$http.erroring(err.msg, true, 1000 * 10);
          })
        }
      })
    },

    openMsg() {
      this.dialogVisibleMsg = true;
    },

    setOpeneds(index) {
      this.openeds = [];
      this.openeds.push(index)
    },
    changeComponent(item) {
      this.changeRouter(item)
    },
    changeRouter(item) {
      this.activeIndex = item.index;
      // console.log(this.activeIndex, this.$refs.homeSide, ' this.activeIndex');

      this.tabList = [];
      this.tabId = '';

      let id = item.url;
      if (id === 'userSetting'
      ) {
        this.$nextTick(() => {
          this.tabList = tabOption[id];
          this.firstChangeTab(this.tabList);
        });
        this.$router.push('settingView');
      } else if (id === 'staticView' ||
        id === 'serviceView' ||
        id === 'surveyView' ||
        id === 'pagetableView' ||
        id === 'postMessage') {
        this.$nextTick(() => {
          this.tabList = tabOption[id];
          this.firstChangeTab(this.tabList);
        });
        this.$router.push(id);
      } else {
        this.$router.push(id);
      }
      // else if (id === 'statistics') {
      //   let url = config.BASE_URL, token = lcGet('token');
      //   window.location.href = 'https://qing.linghealth.cn/dataease//#/de-link/ICVSFO4i?token=' + token
      // }
    },
    firstChangeTab(list) {
      // console.log(list, '946');
      const that = this;
      for (let i = 0; i < list.length; i++) {
        if (that.showTab(list[i].power)) {
          that.changeTabSearch(list[i].value);
          return
        }
      }
    },
    showTab(list) {
      if (list.length === 0) return true;
      let tab = false;
      this.now_auth.forEach(v => {
        list.forEach(e => {
          if (v.indexOf(e) > -1) {
            tab = true
          }
        })
      });
      return tab;
    },
    changeTabSearch(tabId) {
      console.log(tabId, '957');
      this.$nextTick(() => {
        this.tabId = tabId;
        this.setPowerComponentId(tabId);
      })
    },
    sideTabShow(item) {
      // 超级管理员不能看个人首页
      let list = item.decide;
      if (!list || list.length === 0) return true;
      // 超级管理员才能看到系统设置
      return this.showTab(list)
    },
    changeTabSearchVerify(tabId) {
      // 提示是否放弃修改，进入其他页面
      this.changeTabSearch(tabId)
    },
  }
}
</script>
<style scoped lang="scss">
.home_page {
  width: 100%;
  height: 100%;

  .header {
    display: flex;
    align-items: center;
    // margin-bottom: 5px;
    // background-color: var(--ui-gray-dark);
    // color: var(--text-secondary-color);
    background-color: #fff;
    color: #606266;

    .title {
      text-align: center;
      cursor: pointer;
      display: flex;
      align-items: center;
      // width: 200px;
      padding-left: 15px;
      box-sizing: border-box;

      .image_title {
        margin-right: 15px;
        width: 40px;
        height: 40px;
        overflow: hidden;
        border-radius: 5px;
      }
    }

    .tab_list {
      flex: 1;
      width: auto;
      position: relative;
      display: flex;
      overflow-x: auto;

      &::-webkit-scrollbar {
        display: none;
      }

      :deep(.demo-tabs) {
        .el-tabs__header {
          margin: 0;
        }
      }

      // align-items: center;
      .tab_item {
        display: flex;
        align-items: center;
        height: 60px;
        white-space: nowrap;
        // line-height: 60px;
        box-sizing: border-box;
        margin: 0 10px;
        // padding: 10px 0;
        cursor: pointer;
        border-bottom: 2px solid transparent;
      }

      .active_item {
        color: #409eff;
        border-bottom: 2px solid #409eff;
      }
    }

    .right_btn {
      display: flex;
      justify-content: right;
      text-align: right;

      .message_text {
        margin-right: 100px;
        color: red;
        width: 500px;
        font-size: 20px;
      }

      .btns {
        display: flex;
        align-items: center;
        margin-right: 20px;

        .iconfont {
          font-size: 26px;
        }
      }

      .select_icon {
        // color: var(--snackbar-success);
        color: var(--success-color);
      }

      .user_box {
        display: flex;
        align-items: center;
        cursor: pointer;

        .user_img {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          overflow: hidden;
          border: 1px solid #eee;
          border-radius: 50%;
        }

        .user_name {
          margin: 0 10px;
        }
      }
    }
  }

  .aside_box {
    width: 200px;
    // border-right: 1px solid #dcdfe6;
    height: calc(100vh - 60px);
    background-color: #fff;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      width: 0;
      height: 0;
      display: none;
    }

    :deep(.el-menu) {
      border-right: 0;
    }

    .iconfont {
      margin-right: 5px;
    }
  }

  .main {
    padding: 8px;
    padding-top: 12px;
    background-color: #f6f6f6;
    height: 100%;

    // border-radius: 8px;
    .main_box {
      width: 100%;
      height: 100%;
      background-color: #fff;
      // border-radius: 8px;
    }

    // background-color: var(--ui-gray-darker);
  }

  .padt_30 {
    padding-top: 30px;
  }
}

.msg_note {
  // color: var(--el-color-warning-light-3);
  color: var(--warning-color);
  font-size: 0.75rem;
}

:deep(.el-sub-menu.is-opened) {
  background-color: rgb(236, 245, 255);

  .el-menu {
    background-color: rgb(236, 245, 255);
  }
}
</style>